import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../utils/metaPixel';
export function Hero() {
  return <section className="relative bg-cream overflow-hidden min-h-[90vh] flex items-center" data-id="element-49">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-0 w-full" data-id="element-50">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-51">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-52">
            <span className="inline-block py-1 px-3 rounded-full bg-beige text-olive text-sm font-medium tracking-wide mb-6" data-id="element-53">
              Método Piel Clara Natural
            </span>
            <h1 className="text-5xl lg:text-6xl xl:text-7xl font-medium text-brown leading-[1.1] mb-6" data-id="element-54">
              Crea una rutina simple y natural para cuidar tu piel desde casa
            </h1>
            <p className="text-lg text-brown/80 mb-10 leading-relaxed max-w-xl font-light" data-id="element-55">
              Descubre una forma más sencilla de cuidar tu piel con rutinas
              claras, ingredientes accesibles y sin complicaciones.
            </p>
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-sage text-white px-8 py-4 rounded-full text-lg font-medium shadow-sm hover:bg-olive transition-colors duration-300" onClick={() => {
            trackEvent('InitiateCheckout', {
              content_name: 'Método Piel Clara Natural'
            });
            window.open('https://ideasquetransforman.store/products/piel-radiante-en-casa', '_blank');
          }} data-id="element-56">
              Acceder ahora
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative h-[500px] lg:h-[700px] w-full rounded-2xl lg:rounded-tl-[100px] lg:rounded-br-[100px] overflow-hidden shadow-xl" data-id="element-57">
            <img src="https://images.unsplash.com/photo-1556228578-0d85b1a4d571?q=80&w=1000&auto=format&fit=crop" alt="Mujer con piel natural y radiante" className="absolute inset-0 w-full h-full object-cover" data-id="element-58" />
            <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent mix-blend-multiply" data-id="element-59" />
          </motion.div>
        </div>
      </div>
    </section>;
}